import { Checkbox, List, Tooltip } from 'antd';
import React from 'react';
import { type FileCard as FileCardType, useFilesUrlWithToken } from 'services';
import fallbackImage from '../../../assets/fallbackImage.png';
import { FileIcon } from '../../FileIcon';
import styles from '../FilePicker.module.scss';
import { CardMenu } from './card-menu';

type FileCardProps = {
  file: FileCardType;
  onDelete?: (file: FileCardType[]) => void;
  onDownload?: (file: FileCardType) => void;
  onDetails?: (file: FileCardType) => void;
  onClick?: (file: FileCardType) => void;
  showMoreMenu?: boolean;
  isChecked?: boolean;
};

const FileCardV2: React.FC<FileCardProps> = ({
  file,
  onDetails = () => {},
  onDelete = () => {},
  onDownload = () => {},
  showMoreMenu = false,
  isChecked = false,
  onClick = () => {},
}) => {
  const fileExt = (file?.url as any)?.split(/[#?]/)?.[0]?.split('.')?.pop()?.trim()?.toLowerCase();
  const { fileUrlWithToken } = useFilesUrlWithToken();

  const hasMoreMenu = showMoreMenu && (!!onDownload || !!onDetails || !!onDelete);

  return (
    <List.Item>
      <Checkbox className={`${styles.cardCheckbox}`} checked={isChecked} onChange={() => onClick(file)}>
        <div className={styles.card}>
          {hasMoreMenu && <CardMenu file={file} onDelete={onDelete} onDownload={onDownload} onDetails={onDetails} />}

          <div className={styles.cardImage}>
            {file.type === 'image' ? (
              <img
                className={styles.cardThumbnail}
                alt={file.alt || file.name}
                src={fileUrlWithToken(file.url) || fallbackImage.toString()}
                onError={(e) => {
                  (e.target as HTMLImageElement).onerror = null;
                  (e.target as HTMLImageElement).src = fallbackImage.toString();
                }}
              />
            ) : (
              <FileIcon ext={fileExt as any} />
            )}
          </div>

          <div className={styles.cardText}>
            <Tooltip title={isChecked && `${file.name}.${fileExt}`} placement="bottomLeft">
              <div className={styles.cardName}>
                <span className={styles.cardNameBase}>{file.name}.</span>
                <span className={styles.cardNameExtension}>{fileExt}</span>
              </div>
            </Tooltip>
          </div>
        </div>
      </Checkbox>
    </List.Item>
  );
};

export const FileCard = React.memo(
  FileCardV2,
  (prev, next) => prev.file.id === next.file.id && prev.isChecked === next.isChecked,
);
